import { useState } from "react";

import PropTypes from "prop-types";

import ButtonNew from "components/atoms/ButtonNew/index";

import CardImageDes from "./CardImageDes";
import CardPostItemFull from "./CardPostItemFull";
import PostItem from "./PostItem";

const Component = ({ data, posts, total }) => {
  const [perPage, setPerPage] = useState(9);
  const [isLoading, setIsLoading] = useState(false);
  const firstPost = posts[0] || null;

  const listPost =
    posts.length > 1 ? posts.filter((item, index) => index > 0) : [];

  const handleLoadMore = () => {
    setIsLoading(!isLoading);
    setTimeout(() => {
      const currentPerPage = perPage + 6;

      setPerPage(currentPerPage);
      setIsLoading(false);
    }, 500);
  };

  return (
    <>
      <section>
        <CardImageDes Card={data.Card} total={total} />
      </section>
      <section>
        <div className="container">
          <div className="row mt-10">
            <div className="col-12">
              <div className="post-horizontal">
                {firstPost ? <CardPostItemFull post={firstPost} /> : <></>}
              </div>
            </div>
          </div>
          {listPost.length > 0 ? (
            <>
              <div className="row mt-10 gap-y-10 lg:mt-20 lg:gap-y-20">
                {listPost.map((item, index) => (
                  <div
                    className={`col-12 lg:col-4 ${
                      index < perPage ? "" : "hidden"
                    }`}
                    key={index}
                  >
                    <PostItem post={item} />
                  </div>
                ))}
              </div>
              {perPage < listPost.length ? (
                <div className="mt-10 text-center">
                  <ButtonNew
                    othersClass={`${isLoading ? "cursor-not-allowed" : ""}`}
                    onClick={handleLoadMore}
                    disabled={isLoading}
                  >
                    {isLoading ? (
                      <div className="flex items-center">
                        <svg
                          className="text-primary mr-2 h-5 w-5 animate-spin group-hover:text-white"
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                        >
                          <circle
                            className="opacity-25"
                            cx="12"
                            cy="12"
                            r="10"
                            stroke="currentColor"
                            strokeWidth={4}
                          />
                          <path
                            className="opacity-75"
                            fill="currentColor"
                            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                          />
                        </svg>
                        Loading...
                      </div>
                    ) : (
                      <>Load more</>
                    )}
                  </ButtonNew>
                </div>
              ) : (
                <></>
              )}
            </>
          ) : (
            <></>
          )}
        </div>
      </section>
    </>
  );
};

export default Component;

Component.propTypes = {
  data: PropTypes.object,
  posts: PropTypes.array,
};

Component.defaultProps = {
  data: {},
  posts: [],
};
